export default {
    getAllPlans (state) {
        return state.plans
    },
    getDefaultPlan (state) {
        return state.defaultPlan
    }
}



// WEBPACK FOOTER //
// ./src/store/plans/getters.js